export type Testimonial = {
  quote: string
  name: string
  role: string
  initials: string
  photo?: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'En una tarde configuré todo mi iPhone de cero. Ahora la batería me dura hasta la noche y por fin entiendo para qué sirve cada ajuste.',
    name: 'Carolina M.',
    role: 'Docente · Córdoba',
    initials: 'CM',
    photo: 'https://cdn.magicpatterns.com/uploads/bo2nTwaCZHi1fExUNVYU4o/img_cns_2.jpg',
  },
  {
    quote:
      'Venía de Android y estaba perdidísimo. Con la guía aprendí AirDrop, iCloud y los atajos en menos de una semana.',
    name: 'Diego R.',
    role: 'Comerciante · Rosario',
    initials: 'DR',
    photo: 'https://cdn.magicpatterns.com/uploads/5FsqgpDxMYr6bRCve1gKw1/img_cns_3.jpg',
  },
  {
    quote: 'Las fotos de mis viajes cambiaron por completo. Solo con el manual de cámara ya valió lo que pagué.',
    name: 'Nicolás P.',
    role: 'Estudiante · Buenos Aires',
    initials: 'NP',
    photo: 'https://cdn.magicpatterns.com/uploads/knEusFD3SZYpGA3kbnTUnL/img_cns.jpg',
  },
  {
    quote:
      'El checklist de seguridad me dio tranquilidad. Revisé permisos, contraseñas y copias de seguridad en una hora.',
    name: 'Martín S.',
    role: 'Contador · Mendoza',
    initials: 'MS',
    photo: 'https://cdn.magicpatterns.com/uploads/8nhTH2ydWcG415hBv9xLyp/img_cns_4.jpg',
  },
  {
    quote:
      'Tengo 62 años y todo está explicado tan simple que pude aplicarlo sola, sin pedirle ayuda a mis hijos.',
    name: 'Susana G.',
    role: 'Jubilada · Santa Fe',
    initials: 'SG',
  },
]
